import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Route, Switch, Redirect, useHistory } from "react-router-dom";
import Profile from "../Dashboard/Profile";
import CreateProperty from "../Dashboard/CreateProperty";
import ViewProperty from "../Dashboard/ViewProperty";
import TradeProperty from "../Dashboard/TradeProperty";
import Portfolio from "../Dashboard/Portfolio";
import UnifiedHeader from "../Includes/UnifiedHeader";
import Footer from "../Includes/Footer";

const DashboardLayout = () => {
  const history = useHistory();
  const { auth } = useSelector((state) => state);

  useEffect(() => {
    // Redirect to login if not authenticated (no data, or status 0)
    if (!auth.data || auth.data.status === 0) {
      history.push("/login");
      return;
    }
    window.scrollTo(0, 0);
  }, [auth, history]);

  return (
    <div>
      <UnifiedHeader />
      {/* UnifiedHeader already renders a spacer div, so content starts below the fixed bar */}
      <div className="dashboard-page" style={{ minHeight: "calc(100vh - 68px - 200px)", padding: "24px 0" }}>
        <Switch>
          <Route exact path="/dashboard/profile">
            <Profile />
          </Route>
          <Route exact path="/dashboard/createproperty">
            <CreateProperty />
          </Route>
          <Route exact path="/dashboard/viewproperty/:id">
            <ViewProperty />
          </Route>
          <Route exact path="/dashboard/tradeproperty/:id">
            <TradeProperty />
          </Route>
          {/* Transactions and Withdrawals are now tabs inside Portfolio */}
          <Route exact path="/dashboard/transactions">
            <Redirect to="/dashboard/portfolio" />
          </Route>
          <Route exact path="/dashboard/withdrawals">
            <Redirect to="/dashboard/portfolio" />
          </Route>
          <Route exact path="/dashboard/portfolio">
            <Portfolio />
          </Route>
        </Switch>
      </div>
      <Footer />
    </div>
  );
};

export default DashboardLayout;
